import { ZERO_BIG_NUMBER } from '@ui/lib/bignumber';
import { useMemo } from 'react';

import { usePriceMapLatest } from '../price/usePriceLatest';
import { usePriceLiveStore } from '../price/usePriceLive';
import { usePositions } from './usePositions';
import { useTradePairInfos } from './useTradePairInfos';

/**
 * LIVE data, use carefully
 */
export const useTotalUnrealizedPnLLive = () => {
  const { data: positions } = usePositions();
  const pairs = useTradePairInfos();
  const livePriceMap = usePriceLiveStore();
  const { data: latestPriceMap } = usePriceMapLatest();

  return useMemo(() => {
    if (!positions || !livePriceMap) {
      return;
    }

    if (Object.values(livePriceMap).some((v) => !v)) {
      // if any price not fetched, rather show undefine
      return;
    }

    return positions.reduce((acc, p) => {
      const pairMarketPrice = livePriceMap.priceRecord?.[p.pair.baseSymbol];
      const collateralMarketPrice = latestPriceMap?.[p.collateralToken.symbol];

      const tradePair = pairs?.find(
        (pair) => pair.base.toLowerCase() === p.pair.address.toLowerCase(),
      );

      if (!pairMarketPrice || !collateralMarketPrice || !tradePair) {
        return acc;
      }

      const feeConfig = tradePair.feeConfig;

      if (!feeConfig) return acc;

      return acc.plus(
        p.getPnlAfterFee({
          ...feeConfig,
          pairMarketPrice,
          collateralMarketPrice,
          tradePair,
        }),
      );
    }, ZERO_BIG_NUMBER);
  }, [latestPriceMap, livePriceMap, pairs, positions]);
};
